module.exports = __webpack_public_path__ + "img/hello.f9a162de.svg";